import React from 'react';
import * as styles from '../Card.style';

export type CardTextProps = React.PropsWithChildren<{}>;

const CardText: React.FC<CardTextProps> = ({
  children,
}) => (
  <div css={styles.text}>
    {children}
  </div>
);

export default CardText;
